




































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate/dist/types/components/Observer.d";
import HasValidation from "@/mixins/HasValidation";
import { ITaxTag } from "@/models/tax";
import TaxTagsProvider from "@/components/app/global/tax/tags/taxTagsProvider.vue";
import TaxTagsListing from "@/components/app/global/tax/tags/taxTagsListing.vue";

@Component({
  components: {
    TaxTagsListing,
    TaxTagsProvider
  }
})
export default class ManageTaxTagsModal extends Mixins(HasValidation) {
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    taxTagsListing: TaxTagsListing;
  };

  // Data

  // Props
  // @Prop({ required: true })
  // public readonly taxTemplate!: ITaxTemplate;

  @Prop({ default: () => [] })
  public readonly selectedTaxTags!: ITaxTag[];

  @Prop({ default: true })
  public readonly editable!: boolean;

  // Data
  public isProcessing = false;
  // public selected: ITaxTag[] = this.$_.cloneDeep(this.selectedTaxTags);
  public checkedTaxTags: ITaxTag[] = this.$_.cloneDeep(this.selectedTaxTags);

  // Getters
  public get checkedTaxTagsId() {
    return this.checkedTaxTags.map(i => i.id);
  }

  public get hasChange() {
    return !this.$_.isEqual(
      this.selectedTaxTags.map(i => i.id).sort(),
      this.checkedTaxTags.sort()
    );
  }

  public get i18n() {
    return {
      title: this.editable
        ? this.$t("_action.manage_object", {
            object: this.$t("_.tax_tags")
              .toString()
              .toLowerCase()
          })
        : this.$t("_action.view_object", {
            object: this.$t("_.tax_tags")
              .toString()
              .toLowerCase()
          })
    };
  }

  // Methods

  public onCheck({ isChecked, taxTag }) {
    if (isChecked && !this.checkedTaxTags.find(i => i.id === taxTag.id)) {
      this.checkedTaxTags.push(taxTag);
    }
    if (!isChecked && this.checkedTaxTags.find(i => i.id === taxTag.id)) {
      this.checkedTaxTags = this.checkedTaxTags.filter(i => i.id !== taxTag.id);
    }
  }

  public async save() {
    try {
      this.isProcessing = true;
      this.$emit("success", { taxTags: this.checkedTaxTags });
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public addTaxTag() {
    this.$refs.taxTagsListing.taxTagsProvider.openAddEditModal({} as ITaxTag);
  }
}
